var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6V42H38V18H28C26.8954 18 26 17.1046 26 16V6H10ZM9.6 2C8.61826 2 7.6941 2.407 7.02585 3.10309C6.36027 3.79641 6 4.71995 6 5.66667V42.3333C6 43.28 6.36027 44.2036 7.02585 44.8969C7.6941 45.593 8.61827 46 9.6 46H38.4C39.3817 46 40.3059 45.593 40.9741 44.8969C41.6397 44.2036 42 43.28 42 42.3333V15.6667C42 15.1504 41.8003 14.6541 41.4428 14.2816L30.2428 2.61494C29.8656 2.22208 29.3446 2 28.8 2H9.6ZM30 8.13795L35.6276 14H30V8.13795ZM24 22C25.1046 22 26 22.8954 26 24V26.5H28.5C29.6046 26.5 30.5 27.3954 30.5 28.5C30.5 29.6046 29.6046 30.5 28.5 30.5H26V33C26 34.1046 25.1046 35 24 35C22.8954 35 22 34.1046 22 33V30.5H19.5C18.3954 30.5 17.5 29.6046 17.5 28.5C17.5 27.3954 18.3954 26.5 19.5 26.5H22V24C22 22.8954 22.8954 22 24 22Z",
    fill: "#999FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file_plus.d9252c3275d357967177c845bd471b1c.svg";
export { ForwardRef as ReactComponent };